import { Box } from '@mui/material';
import { OnChangeFn } from '@tanstack/react-table';
import { MRT_SortingState } from 'material-react-table';
import { BikeleasingContractListItemDTO } from 'probonio-shared-ui/api';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { InfiniteScrollReactTable } from '../../../../component/table/InfiniteScrollReactTable';
import { useBikeleasingContractColumns } from '../useBikeleasingContractColumns';

interface Props {
  contracts: BikeleasingContractListItemDTO[];
  sorting: MRT_SortingState;
  onSortingChange: OnChangeFn<MRT_SortingState>;
  isLoading?: boolean;
}

const BikeleasingContractsTable: React.FC<Props> = ({ contracts, sorting, onSortingChange, isLoading }) => {
  const { t } = useTranslation('benefitsModule');
  const columns = useBikeleasingContractColumns();
  return (
    <Box data-test-id="bikeleasing-contracts-table">
      <InfiniteScrollReactTable
        data={contracts}
        rowCount={contracts.length}
        onLoadMore={() => {
          // all rows are loaded and cached upfront
        }}
        hasMore={false}
        isLoading={isLoading}
        isFetching={false}
        columns={columns}
        enablePagination={false}
        enableTopToolbar={false}
        enableBottomToolbar={false}
        enableColumnActions={false}
        manualSorting
        state={{ sorting }}
        onSortingChange={onSortingChange}
        localization={{ noRecordsToDisplay: t('extensions:bikeleasing_v2.contractsTable.noResults') }}
      />
    </Box>
  );
};

export default React.memo(BikeleasingContractsTable);
